import { useQuery } from "@tanstack/react-query";
import { salonProfileQuery } from "../api/salon.queries";

/**
 * Until the profile has loaded, instants are read in India Standard Time, the zone the server gives
 * an Indian salon's branch. The browser's zone is never used: a customer travelling, or a phone set
 * to UTC, must still see the 11:00 appointment at 11:00.
 */
export const FALLBACK_TIME_ZONE = "Asia/Kolkata";

/** The zone every time on this app is shown in: the salon's, never the phone's. */
export function useSalonTimeZone(): string {
  const { data } = useQuery(salonProfileQuery());
  return data?.branch?.timezone ?? FALLBACK_TIME_ZONE;
}
